import * as types from './types';
import {
  STUDENT_IMAGE_STATUS_DISPLAY_IMAGE,
  STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE,
  STUDENT_IMAGE_STATUS_DISPLAY_PREVIEW,
  STUDENT_IMAGE_STATUS_DISPLAY_STOCK_PREVIEW,
} from 'Common/Constants/';

export const setStudentImage = imageData => ({
  type: types.ACCOUNT_SETUP_STUDENT_IMAGE_SET_IMAGE,
  payload: imageData,
});

export const clearStudentImage = () => ({
  type: types.ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_IMAGE,
});

export const setImageStatus = imageStatus => ({
  type: types.ACCOUNT_SETUP_STUDENT_IMAGE_SET_STATUS,
  payload: imageStatus,
});

export const displayDropzone = setImageStatus(
  STUDENT_IMAGE_STATUS_DISPLAY_DROPZONE
);

export const displayPreview = setImageStatus(
  STUDENT_IMAGE_STATUS_DISPLAY_PREVIEW
);

export const displayStockPreview = setImageStatus(
  STUDENT_IMAGE_STATUS_DISPLAY_STOCK_PREVIEW
);

export const displayImage = setImageStatus(STUDENT_IMAGE_STATUS_DISPLAY_IMAGE);

export const getStudentPicture = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const {
        AccountSetupState: { studentSeedData: { Result: { IdSeed } } },
      } = getState();

      if (IdSeed) {
        const response = await MPWWebApi.getGeneric(
          `student/picture/${IdSeed}`
        );

        if (response && response.data) {
          const { data: responseData = {} } = response;
          const { Data, Errors = [] } = responseData;

          if (Data) {
            dispatch(setStudentImage(Data));
          } else if (!Data) {
            dispatch(clearStudentImage());
          } else if (Errors.length) {
            console.error('Problem posting student picture', ...Errors);
          }
        }
      }
    } catch (error) {
      console.error('Problem getting student picture', error.response);
    }
  };
};

export const postStudentPicture = async (file, idSeed, MPWWebApi) => {
  if (idSeed && file && file !== '') {
    let formData = new FormData();
    formData.append('file', file);

    const response = await MPWWebApi.postGenericFile(
      `student/picture/${idSeed}`,
      formData,
      null,
      false // do not display progress bar
    );

    if (response && response.data) {
      const { data: responseData = {} } = response;
      const { Errors = [] } = responseData;

      if (Errors.length) {
        console.error('Problem getting student picture', ...Errors);
      }
    }
  }
};

export const deleteStudentPicture = idSeed => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      await MPWWebApi.postGenericDelete('Student/Picture', idSeed);
    } catch (error) {
      console.error('Problem deleting student picture', error.response);
    }
  };
};

export const studentPictureError = error => {
  return {
    type: types.ACCOUNT_SETUP_STUDENT_IMAGE_ERROR,
    payload: error,
  };
};

export const clearStudentPictureError = () => {
  return {
    type: types.ACCOUNT_SETUP_STUDENT_IMAGE_CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/studentinfo/actions.js